
const WorkIcon = () => {
  return (
    <div className="w-12 relative flex items-center justify-center text-gray-900 font-bold">
      <img
      src="assets/skills/react.png"
      alt="react"
      className="w-8 sm:w-8 h-8 mt-1 ml-[-8px] md:w-9 md:h-9 md:mt-[0.5] lg:w-9 lg:h-9 xl:w-12 xl:h-12 xl:mt-1.5 xl:ml-[12px]"
      />
    </div>
    )
}

export default WorkIcon